import covenant from '../components/covenant'

export default {
  covenant
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/index/resources/components.js